import { render, staticRenderFns } from "./log.vue?vue&type=template&id=53edb175&scoped=true&"
var script = {}
import style0 from "./log.vue?vue&type=style&index=0&id=53edb175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53edb175",
  null
  
)

export default component.exports